/* Patamora v3: asistente "Pata" con tickets y reapertura de la bienvenida tras dejar el email. */

const session = {
  get(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key));
    } catch (e) {
      return null;
    }
  },
  set(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* almacenamiento no disponible */
    }
  },
};

/* ---------- Bienvenida: tras enviar el email la página se recarga; volvemos a abrirla con el código ---------- */

function initWelcomeResult() {
  const dialog = document.querySelector('[data-pm-welcome]');
  if (!dialog) return;
  if (dialog.hasAttribute('data-posted') || dialog.hasAttribute('data-errored')) {
    const tab = document.querySelector('[data-pm-welcome-tab]');
    if (tab) tab.hidden = true;
    if (!dialog.open) dialog.showModal();
  }
}

/* ---------- Asistente ---------- */

// Palabras clave por intención. Se comparan sin tildes y en minúsculas; gana la intención con más puntos.
// Las respuestas están en snippets/pm-chat.liquid (<template data-a="intención">).
const INTENTS = [
  // Problemas con un pedido (pesan más que todo lo demás).
  ['roto', ['roto', 'rota', 'defectuos', 'danad', 'mal estado', 'no funciona', 'falta', 'incomplet', 'equivocad', 'otro color', 'llego mal', 'ha llegado mal', 'despegad', 'descosid']],
  ['pedido', ['cancelar', 'anular', 'cambiar la direccion', 'cambiar direccion', 'modificar', 'me equivoque', 'direccion mal', 'otra direccion de entrega']],
  // Envíos.
  ['seguimiento', ['seguimiento', 'tracking', 'rastre', 'donde esta', 'no me ha llegado', 'no ha llegado', 'no llega', 'localizar', 'estado de mi pedido', 'mi pedido', 'numero de envio']],
  ['paquetes', ['paquete', 'solo un paquete', 'separado', 'por partes', 'solo me ha llegado', 'falta un paquete', 'dos paquetes', 'varios paquetes', 'llego solo uno', 'juntos']],
  ['plazo', ['cuando llega', 'cuando me llega', 'llega', 'cuanto tarda', 'tarda', 'plazo', 'cuantos dias', 'en cuantos dias', 'dias tarda', 'dias habiles', 'entrega', 'cuando recib', 'llegara', 'urgente', 'antes de']],
  ['origen', ['desde donde', 'de donde', 'china', 'aliexpress', 'almacen', 'dropshipping', 'quien envia', 'se envia desde', 'fabricad', 'procedencia']],
  ['zonas', ['canarias', 'ceuta', 'melilla', 'portugal', 'francia', 'andorra', 'extranjero', 'internacional', 'fuera de espana', 'tenerife', 'las palmas', 'mallorca', 'ibiza', 'menorca', 'baleares']],
  ['envio', ['envio', 'gastos', 'portes', 'gratis', 'coste de envio', 'cuanto cuesta enviar', 'mandais', 'enviais', 'transportista', 'correos', 'mensajeria']],
  ['regalo-envio', ['regalar', 'para regalo', 'envolver', 'envoltorio', 'otra persona', 'otra direccion']],
  // Dinero.
  ['devolucion', ['devol', 'devuelvo', 'reembols', 'no me gusta', 'desistimiento', 'arrepent', 'dinero']],
  ['cambio-talla', ['cambiar la talla', 'cambio de talla', 'otra talla', 'le queda pequeno', 'le queda grande', 'no le vale', 'no le queda']],
  ['garantia', ['garantia', 'se ha roto', 'dejo de funcionar', 'se rompio', 'duracion']],
  ['plazos-pago', ['plazos', 'a plazos', 'klarna', 'pagar despues', 'pagar mas tarde', 'financiar', 'aplazar']],
  ['pago', ['pago', 'pagar', 'paypal', 'tarjeta', 'bizum', 'visa', 'mastercard', 'transferencia', 'contrareembolso', 'contra reembolso', 'iva', 'aduana', 'apple pay', 'google pay', 'seguro pagar']],
  ['factura', ['factura', 'nif', 'cif', 'empresa', 'autonomo', 'ticket de compra', 'recibo']],
  ['descuento', ['descuento', 'cupon', 'codigo', 'promo', 'oferta', 'rebaja', 'bienvenida', 'black friday', 'rebajas']],
  ['regalo', ['guia', 'la guia', 'ebook', 'pdf', 'libro', 'ruidos sin sustos', 'de regalo', 'regalais']],
  // Producto en general.
  ['tallas', ['talla', 'tallas', 'que talla', 'medir', 'medida del perro', 'contorno', 'pecho', 'cuello', 'tabla de tallas']],
  ['tamano-perro', ['perro grande', 'perros grandes', 'raza grande', 'perro pequeno', 'chihuahua', 'pastor aleman', 'labrador', 'golden', 'galgo', 'bulldog', 'cachorro']],
  ['medidas', ['medida', 'tamano', 'material', 'capacidad', 'cuanto mide', 'peso', 'dimensiones', 'de que esta hecho']],
  ['lavado', ['lavar', 'lava', 'se lava', 'como se limpia', 'lavadora', 'limpiar', 'limpia', 'secadora', 'mancha', 'lavavajillas']],
  ['seguridad', ['seguro para', 'toxico', 'peligroso', 'se lo puede comer', 'morder', 'muerde', 'alergia', 'bpa']],
  ['stock', ['stock', 'hay stock', 'teneis stock', 'agotado', 'disponible', 'reponer', 'cuando vuelve', 'hay unidades', 'quedan']],
  ['no-vendemos', ['pienso', 'comida para', 'comida de', 'hamster', 'conejo', 'pajaro', 'peces', 'loro', 'antiparasit', 'pipeta', 'medicamento', 'antipulgas', 'arena para gato', 'rascador', 'jaula', 'transportin', 'arnes', 'collar']],
  // La tienda.
  ['fiable', ['fiable', 'fiables', 'estafa', 'timo', 'de fiar', 'confianza', 'seguro comprar', 'opiniones', 'resenas', 'valoraciones', 'sois reales']],
  ['tienda-fisica', ['tienda fisica', 'donde estais', 'direccion de la tienda', 'recoger', 'ir a la tienda']],
  ['horario', ['horario', 'a que hora', 'fin de semana', 'sabado', 'domingo', 'cuando contestais', 'cuanto tardais en responder']],
  ['cuenta', ['cuenta', 'registrar', 'registro', 'contrasena', 'iniciar sesion', 'login', 'mis pedidos']],
  ['baja', ['darme de baja', 'doy de baja', 'de baja', 'baja', 'cancelar suscripcion', 'no quiero emails', 'borrar mis datos', 'mis datos', 'privacidad', 'spam']],
  ['contacto', ['persona', 'humano', 'agente', 'ticket', 'contacto', 'contactar', 'hablar con', 'email', 'correo electronico', 'telefono', 'llamar', 'whatsapp', 'queja', 'reclamacion', 'atencion al cliente']],
  // Productos: las respuestas salen de la tienda (precio y colores reales).
  ['p-pack-calma-ruidos', ['pack calma', 'calma ruidos']],
  ['p-pack-petardos', ['pack petardos', 'pack de petardos']],
  ['p-pack-manos-libres', ['pack manos libres']],
  ['p-pack-gato-calentito', ['gato calentito', 'pack calentito', 'calentito']],
  ['p-pack-gato-feliz', ['gato feliz', 'pack gato', 'pack de gato']],
  ['p-pack-paseo', ['pack paseo', 'pack de paseo']],
  ['p-pack-casa-sin-pelos', ['pack casa', 'casa sin pelos']],
  ['p-pack-sin-pelos-total', ['sin pelos total', 'pack total', 'pack completo']],
  ['p-chaleco-calmante-perros', ['chaleco', 'thundershirt', 'antiestres', 'capucha calmante']],
  ['p-orejeras-para-perros', ['orejera', 'cascos', 'tapones', 'protector de oidos', 'antiruido', 'anti ruido']],
  ['p-alfombrilla-olfativa-perros', ['olfativ', 'olfato', 'snuffle', 'esconder premios']],
  ['p-chubasquero-reflectante', ['chubasquero', 'impermeable', 'abrigo de lluvia', 'capa de lluvia', 'reflectante']],
  ['p-vaso-limpiapatas', ['limpiapatas', 'limpia patas', 'patas sucias', 'lavar patas', 'barro']],
  ['p-correa-manos-libres-perros', ['manos libres', 'correa', 'cintura', 'running', 'correr con']],
  ['p-bolsa-de-premios', ['bolsa de premios', 'premios', 'chuches', 'golosinas', 'adiestra']],
  ['p-hamaca-ventana-gatos', ['hamaca', 'ventosa', 'cama de ventana', 'cama ventana']],
  ['p-manta-autocalentable-gatos', ['manta', 'autocalentable', 'termica', 'calentita', 'frio', 'invierno', 'cama caliente']],
  ['p-protector-sofa-gatos', ['aranazo', 'arana', 'rasca el sofa', 'protector de sofa', ' unas ']],
  ['p-cepillo-desenredante', ['cepill', 'peine', 'desenred']],
  ['p-quitapelos-reutilizable', ['quitapelo', 'rodillo', 'quita pelo']],
  ['p-guante-quitapelos', ['guante']],
  ['p-alfombrilla-de-lamer', ['alfombrilla de lamer', 'lamer', 'lick']],
  ['p-botella-de-paseo', ['botella', 'bebedero', 'beber']],
  ['p-dispensador-de-bolsas', ['dispensador', 'bolsas', 'caca', 'excremento']],
  ['packs', ['pack', 'packs', 'lote', 'conjunto', 'combo']],
  ['precios', ['precio', 'cuesta', 'cuestan', 'cuanto vale', 'cuanto valen', 'barato', 'caro', 'catalogo']],
  // Necesidades: cuando no nombran un producto concreto.
  ['elegir-ruidos', ['petardo', 'cohete', 'tormenta', 'trueno', 'fuegos artificiales', 'ruido', 'miedo', 'asusta', 'tiembla', 'nochevieja', 'fallas', 'san juan', 'fiestas']],
  ['elegir-lluvia', ['lluvia', 'llueve', 'mojado', 'se moja', 'charcos']],
  ['elegir-gato', ['gato', 'gatos', 'gatito', 'felino', 'michi']],
  ['elegir-pelo', ['pelo', 'pelos', 'muda', 'sofa', 'alfombra', 'ropa']],
  ['elegir-nudos', ['nudo', 'enredo', 'pelo largo']],
  ['elegir-paseo', ['paseo', 'pasear', 'agua', 'tira de la correa']],
  ['elegir-calma', ['ansiedad', 'nervios', 'nervioso', 'come rapido', 'come muy', 'traga', 'engull', 'aburr', 'tranquil', 'solo en casa', 'se queda solo', 'estres']],
  ['elegir', ['recomiend', 'que me conviene', 'que compro', 'regalo', 'cual elijo', 'ayudame a elegir', 'productos', 'que vendeis', 'que teneis', 'novedades']],
  // Cortesía: solo cuenta si la frase no pide nada más.
  ['gracias', ['gracias', 'genial', 'perfecto', 'ok', 'vale']],
  ['hola', ['hola', 'buenas', 'buenos dias', 'hey', 'saludos']],
];

// Peso por grupo: urgente > servicio > producto > necesidad > cortesía.
const weightOf = (intent) => {
  if (['roto', 'pedido'].includes(intent)) return 12;
  if (['gracias', 'hola'].includes(intent)) return 0.2;
  if (intent === 'contacto') return 4;
  if (intent.startsWith('elegir')) return 2.5;
  if (intent.startsWith('p-') || intent === 'packs') return 3;
  if (intent === 'precios') return 1;
  return 5;
};

// Tras estas respuestas ofrecemos escribir a una persona.
const OFFER_CONTACT_AFTER = new Set(['roto', 'pedido', 'contacto', 'factura', 'garantia', 'cambio-talla', 'paquetes']);

const normalize = (text) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[¿?¡!.,;:]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

function detectIntent(text) {
  // Un saludo ("buenos días") solo se descarta si la frase pide algo más.
  const norm = normalize(text);
  const rest = norm.replace(/\b(buenos dias|buenas tardes|buenas noches|buen dia)\b/g, ' ').replace(/\s+/g, ' ').trim();
  const q = ` ${rest || norm} `;
  let best = null;
  let bestScore = 0;
  for (const [intent, words] of INTENTS) {
    let score = 0;
    for (const w of words) if (q.includes(w)) score += w.length >= 5 ? 2 : 1;
    // Las dudas de servicio pesan más que el producto: "devolver el quitapelos" es una devolución.
    score *= weightOf(intent);
    if (score > bestScore) {
      best = intent;
      bestScore = score;
    }
  }
  return best;
}

function initChat() {
  const root = document.querySelector('[data-pm-chat-root]');
  if (!root) return;

  const panel = root.querySelector('[data-pm-chat]');
  const log = root.querySelector('[data-pm-chat-log]');
  const askForm = root.querySelector('[data-pm-chat-ask]');
  const input = askForm.querySelector('input');
  const fab = root.querySelector('.pm-chat__fab');
  const nudge = root.querySelector('[data-pm-chat-nudge]');
  const ticket = root.querySelector('[data-pm-ticket]');
  const ticketBody = root.querySelector('[data-pm-ticket-body]');
  const ticketLog = root.querySelector('[data-pm-ticket-log]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const answer = (key) => root.querySelector(`template[data-a="${key}"]`)?.innerHTML.trim() || '';

  // Historial de la sesión: sobrevive al cambiar de página y al enviar el ticket.
  let history = session.get('pm-chat-history') || [];
  let lastQuestion = session.get('pm-chat-last') || '';
  // Preguntas seguidas sin respuesta: a la segunda insistimos en la página de contacto.
  let misses = 0;

  const bubble = (who, html, save = true) => {
    const el = document.createElement('div');
    el.className = `pm-chat__msg pm-chat__msg--${who}`;
    if (who === 'me') el.textContent = html;
    else el.innerHTML = html;
    log.append(el);
    log.scrollTop = log.scrollHeight;
    if (save) {
      history.push([who, html]);
      history = history.slice(-30);
      session.set('pm-chat-history', history);
    }
    return el;
  };

  const botSay = (key, extraHtml = '') =>
    new Promise((resolve) => {
      const typing = document.createElement('div');
      typing.className = 'pm-chat__msg pm-chat__msg--bot pm-chat__msg--typing';
      typing.innerHTML = '<i></i><i></i><i></i>';
      log.append(typing);
      log.scrollTop = log.scrollHeight;
      setTimeout(() => {
        typing.remove();
        bubble('bot', (answer(key) || answer('nose')) + extraHtml);
        resolve();
      }, reduceMotion ? 0 : 550);
    });

  const contactButtons =
    '<span class="pm-chat__opts"><a class="pm-chat__inline" href="/pages/contact">Ir a la página de contacto</a>' +
    '<button type="button" class="pm-chat__inline" data-ask="ticket">Abrir un ticket aquí</button></span>';

  const setOpen = (open) => {
    panel.hidden = !open;
    root.classList.toggle('is-open', open);
    root.querySelectorAll('[data-pm-chat-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    if (nudge) nudge.hidden = true;
    session.set('pm-chat-open', open);
    if (open) {
      session.set('pm-chat-nudged', true);
      if (!log.children.length) {
        if (history.length) history.forEach(([who, html]) => bubble(who, html, false));
        else botSay('hola');
      }
      if (window.matchMedia('(hover: hover)').matches) setTimeout(() => input.focus(), 50);
    } else {
      fab.focus({ preventScroll: true });
    }
  };

  const showTicket = (show) => {
    root.classList.toggle('is-ticket', show);
    if (show) {
      if (ticketBody && !ticketBody.value && lastQuestion) ticketBody.value = lastQuestion;
      ticket.querySelector('input:not([type=hidden])')?.focus();
    }
  };

  const reply = async (key) => {
    if (key === 'ticket') {
      await botSay('ticket');
      showTicket(true);
      return;
    }
    if (!key) {
      misses += 1;
      await botSay(misses >= 2 ? 'nose2' : 'nose', contactButtons);
      return;
    }
    misses = 0;
    await botSay(key, OFFER_CONTACT_AFTER.has(key) ? contactButtons : '');
  };

  const handle = async (key, label) => {
    if (label) bubble('me', label);
    await reply(key);
  };

  root.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-pm-chat-toggle]');
    if (toggle) {
      setOpen(panel.hidden);
      return;
    }
    const ask = e.target.closest('[data-ask]');
    if (ask) {
      handle(ask.dataset.ask, ask.closest('.pm-chat__msg') && ask.dataset.ask === 'ticket' ? null : ask.textContent.trim());
      return;
    }
    if (e.target.closest('[data-pm-ticket-cancel]')) showTicket(false);
    if (e.target.closest('[data-pm-open-welcome]')) {
      const dialog = document.querySelector('[data-pm-welcome]');
      if (dialog && !dialog.open) dialog.showModal();
    }
  });

  nudge?.addEventListener('click', () => setOpen(true));

  askForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (!text) return;
    input.value = '';
    lastQuestion = text;
    session.set('pm-chat-last', text);
    bubble('me', text);
    await reply(detectIntent(text));
  });

  ticket?.addEventListener('submit', () => {
    if (ticketLog) {
      const tmp = document.createElement('div');
      ticketLog.value = history
        .map(([who, html]) => {
          tmp.innerHTML = html;
          return `${who === 'me' ? 'Cliente' : 'Pata'}: ${tmp.textContent.replace(/\s+/g, ' ').trim()}`;
        })
        .join('\n');
    }
    session.set('pm-chat-open', true);
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-pm-chat-open]')) setOpen(true);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !panel.hidden) setOpen(false);
  });

  // Vuelta tras enviar el ticket (o con errores en el formulario).
  const sent = root.querySelector('[data-pm-ticket-sent]');
  const errored = root.querySelector('.pm-chat__err');
  if (sent) {
    setOpen(true);
    bubble('bot', answer('enviado'));
    lastQuestion = '';
    session.set('pm-chat-last', '');
  } else if (errored) {
    setOpen(true);
    showTicket(true);
  } else if (session.get('pm-chat-open')) {
    setOpen(true);
  } else if (!session.get('pm-chat-nudged') && nudge) {
    setTimeout(() => {
      if (panel.hidden && !document.querySelector('dialog[open]')) nudge.hidden = false;
      session.set('pm-chat-nudged', true);
      setTimeout(() => (nudge.hidden = true), 9000);
    }, 30000);
  }

  // Si Horizon muestra su barra fija de compra abajo, subimos el botón para que no se tapen.
  // v22: como mucho una lectura de maquetación cada 60 ms (antes, una por cada scroll y cada cambio de
  // atributo) y se arranca 1,2 s después de la carga, no durante ella.
  const watchSticky = () => {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    let timer = 0;
    const update = () => {
      timer = 0;
      const r = bar.getBoundingClientRect();
      const f = fab.getBoundingClientRect();
      const style = getComputedStyle(bar);
      const visible = r.height > 0 && r.top < window.innerHeight - 4 && style.visibility !== 'hidden' && Number(style.opacity) > 0.1;
      const overlaps = r.right > f.left - 8 && r.left < f.right + 8;
      root.style.setProperty('--pm-chat-lift', visible && overlaps ? `${Math.ceil(window.innerHeight - r.top) + 4}px` : '0px');
    };
    const schedule = () => {
      if (!timer) timer = setTimeout(update, 60);
    };
    new MutationObserver(schedule).observe(bar.closest('sticky-add-to-cart') || bar, { attributes: true, subtree: true });
    bar.addEventListener('transitionend', schedule);
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule);
    update();
  };
  setTimeout(watchSticky, 1200);
}

initWelcomeResult();
initChat();
